var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSlideshow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "slideshow"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2833_2408",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2833_2408)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "slideshow_2",
    d: "M10.1168 16.3168L16.8 12L10.1168 7.68325V16.3168ZM5.16675 21C4.71675 21 4.32642 20.8348 3.99575 20.5043C3.66525 20.1736 3.5 19.7833 3.5 19.3333V4.66675C3.5 4.21675 3.66525 3.82642 3.99575 3.49575C4.32642 3.16525 4.71675 3 5.16675 3H19.8333C20.2833 3 20.6736 3.16525 21.0043 3.49575C21.3348 3.82642 21.5 4.21675 21.5 4.66675V19.3333C21.5 19.7833 21.3348 20.1736 21.0043 20.5043C20.6736 20.8348 20.2833 21 19.8333 21H5.16675ZM5.16675 19.3333H19.8333V4.66675H5.16675V19.3333Z",
    fill: "#1C1B1F"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSlideshow);
export default __webpack_public_path__ + "static/media/icon-slideshow.e7f2a4a367362cbbd6e18cd1ade33a95.svg";
export { ForwardRef as ReactComponent };